import { render, staticRenderFns } from "./confirmUpdateServiceWorker.vue?vue&type=template&id=e5e98aba&scoped=true"
import script from "./confirmUpdateServiceWorker.vue?vue&type=script&lang=js"
export * from "./confirmUpdateServiceWorker.vue?vue&type=script&lang=js"
import style0 from "./confirmUpdateServiceWorker.vue?vue&type=style&index=0&id=e5e98aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e98aba",
  null
  
)

export default component.exports